export const ENV_NAME = {
  LOCAL: 'local',
  DEV: 'dev',
  IT: 'it',
  UAT: 'uat',
  STAGING: 'staging',
  PROD: 'prod',
  DEMO: 'demo',
};

export const MODE = {
  DEV: 'development',
  PROD: 'production',
};

export const HTTP_RESPONSE_STATUS_CODE = {
  UNAUTHORIZED: 401,
};

export const HTTP_RESPONSE_ERROR_CODE = {
  MSG_ERROR_COMMON_003: 'MSG_ERROR_COMMON_003',
  MSG_ERROR_APPCOMMON_009: 'MSG_ERROR_APPCOMMON_009',
};

// react-oidcのEventName
export const OIDC_EVENT_NAME = {
  LOGIN_CALLBACK_ASYNC_ERROR: 'loginCallbackAsync_error',
  TRY_KEEP_EXISTING_SESSION_ASYNC_END: 'tryKeepExistingSessionAsync_end',
};

// ログイン失敗した時のリダイレクト上限回数
export const AUTH_VALIDATION_RETRY_COUNT_NUM = 5;

// API取得件数
export const API_SEARCH_LIMIT = 30;

// 他システムから渡されるパラメータ
export const PARAM_NAME = {
  SYSTEM: 'system',
  LOGIN_ID: 'loginId',
  ONE_TIME_ID: 'oneTimeId',
  REDIRECT_PAGE: 'redirectPage',
};
